import axios from "@//plugins//axios.js";

const actions = {
  async set_escuela({ commit }) {
    try {
      const { data } = await axios.get("escuela");
      commit("SET_ESCUELA", data);
      return data;
    } catch (error) {
      return null;
    }
  },
};

export default actions;
